import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import 'rxjs/add/operator/map';
//import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class AdminGuard implements CanActivate{

  constructor (
    private router:Router,
    public authService: AuthService,
  //  public afAuth:AngularFireAuth
    ){}


    canActivate(): Observable<boolean>{  // boolean {

      return this.authService.afAuth.authState.map(auth => {
        if(!auth){
            this.router.navigate(['/']);
            return false;
        } else {
          /*console.log( 'DANS ADMIN A PROFUSION' , auth);
           console.log('USER ROLES DANS AdmIN GUARD', this.authService.userRoles)
          console.log('USER ADMIN', this.authService.isSuperAdmin)*/
          return this.authService.isSuperAdmin === true;
        }
      });
/* ca marchaut avec ca
      return this.authService.currentUserObservable.map( auth => {
           if(!auth) {
             return false;
           } else {
            console.log( 'DANS ADMIN A PROFUSION' , auth);
            console.log('USER ROLES DANS AdmIN GUARD', this.authService.userRoles)
            console.log('USER ADMIN', this.authService.isSuperAdmin)
            return this.authService.isSuperAdmin === true;
          }
        })
*/
/*
        return this.afAuth.authState.map(auth => {
         if( !auth ){
             //this.router.navigate(['/session/signin']);
             return false;
         } else {
          if(! this.authService.displayUser.roles.superadmin) {
            return false
          }  else {return true }
         }
       });
       */
     }

}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/guards/admin.guard.ts